var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRecording = function SvgIconRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.588 7.862H8.296m5.433 4.628 3.875 1.908c.402.245.823.1.813-.41l-.027-6.745c-.035-.553-.361-.705-.843-.449l-3.828 1.74m-8.844 7.383h6.963c1.036 0 1.875-.829 1.875-1.851l.016-2.376-.016-4.754c0-1.023-.84-1.852-1.875-1.852H4.875C3.839 5.084 3 5.914 3 6.936v7.13c0 1.022.84 1.851 1.875 1.851"
  })));
};
export default SvgIconRecording;